import { declareModel, type InferModel } from "@monade/json-api-parser";
import z from "zod";

export const UserRole = {
  User: 'user',
  Admin: 'admin',
} as const;

export const UserRoleEnum = z.enum(['user', 'admin']);
export type UserRoleType = z.infer<typeof UserRoleEnum>;

export const UserSchema = declareModel(
  "users",
  {
    attributes: z.object({
      authId: z.string(),
      email: z.string(),
      emailVerified: z.boolean(),
      role: UserRoleEnum,
      createdAt: z.string().transform((v) => new Date(v)),
      updatedAt: z.string().transform((v) => new Date(v)),
    }),
    relationships: z.object({}),
  }
);

export type User = InferModel<typeof UserSchema>;
